import { AutoComplete, DatePicker, Form, Input } from 'antd';
import { useForm } from 'antd/es/form/Form';
import FormItem from 'antd/es/form/FormItem';
import { FormInstance } from 'antd/lib';
import { RefObject, useImperativeHandle } from 'react';
import { useEmployeeTypes } from '../../utils/api-hooks/employee.hook';
import { map } from 'lodash';

type EmployeeFormProps = {
  formRef: RefObject<FormInstance>;
  initialValues?: any;
};

export default function EmployeeFormComponent(props: EmployeeFormProps) {
  const { formRef, initialValues } = props;
  const [form] = useForm();
  const { data: { data: employeeTypes } = {} } = useEmployeeTypes();

  useImperativeHandle(formRef, () => form, [form]);

  return (
    <Form
      form={form}
      autoComplete="off"
      preserve={false}
      initialValues={initialValues}
    >
      <FormItem
        label="姓名"
        name="name"
        rules={[{ required: true, message: '請輸入姓名' }]}
      >
        <Input />
      </FormItem>
      <FormItem
        label="電話號碼"
        name="phone"
        rules={[
          { required: true, message: '請輸入電話號碼' },
          { len: 10, message: '電話號碼必須為 10 碼' },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem
        label="生日"
        name="birthday"
        rules={[{ required: true, message: '請選擇生日' }]}
      >
        <DatePicker />
      </FormItem>
      <FormItem
        label="入職時間"
        name="onBoardingTime"
        rules={[{ required: true, message: '請選擇入職時間' }]}
      >
        <DatePicker />
      </FormItem>
      <FormItem
        label="員工類型"
        name="type"
        rules={[{ required: true, message: '請選擇員工類型' }]}
      >
        <AutoComplete
          options={map(employeeTypes, (item) => ({
            value: item,
          }))}
        />
      </FormItem>
      <FormItem
        label="身分證字號"
        name="nationalIdNumber"
        rules={[
          { len: 10, message: '身分證字號必須為 10 碼' },
          {
            pattern: /^[A-Z]\d{9}$/,
            message: '請輸入正確的身分證字號格式',
          },
        ]}
      >
        <Input />
      </FormItem>
      <FormItem
        label="電子郵件"
        name="email"
        rules={[{ type: 'email', message: '請輸入正確的電子郵件' }]}
      >
        <Input />
      </FormItem>
    </Form>
  );
}
